
import { io } from 'socket.io-client';
import { DATA_EVENTS, EVENTS, INTERNAL_EVENTS, SDK_EVENTS } from '../constants/events.cnst';
import { IdMapConstant, ProjConstants, storageConst } from '../constants/projConsts';
import { ERROR_CODES } from '../constants/errorcodes';
import KoreGenerateuuidPipe from '../utils/koregenerateuuid';
import SocketEncryptionService from './socket-encryption.service';
class websocketservice {

    private _agentAssistSocket: any;
    private hostIns: any;
    private configOptions: any;
    private socketEncryption: SocketEncryptionService;

    prevTimeStamp : number = 0;
    intervalTime : number = 510;
    count = 1;
    dialogEntityExtraction : boolean = false;

    constructor(hostIns: any) {
        this.hostIns = hostIns;
        this.socketEncryption = new SocketEncryptionService();
        this.hostIns.on(INTERNAL_EVENTS.INTERNAL_TRANSFER, (data : any) => {
            this.handleInternalTransfer(data);
        });
    }

    socketConnection(configOptions: any, grantResponseObj: any, language: string) {

        const { conversationId, botId, token, channel } = this.hostIns.rootService.connectionDetails;
        let queryParams : any = {
          accountId: grantResponseObj?.userInfo?.accountId,
          botId,
          experience: channel,
          conversationId,
          userId : grantResponseObj?.userInfo?.userId,
          language,
          interactiveLang: this.hostIns?.config?.connectionDetails?.interactiveLanguage,
          accessToken: grantResponseObj?.authorization?.accessToken,
          cE : true
        }

        this.configOptions = configOptions;
        let finalUrl =  configOptions?.connectionDetails?.domainURL+'/koreagentassist';
        const subPath = grantResponseObj?.invokeNewAAService ? 'agentai' : 'agentassist';
        const config = {
            url: finalUrl,
            options: {
                path: `/${subPath}/api/v1/chat`,
                autoConnect: false,
                transports: ['websocket', 'polling', 'flashsocket'],
                reconnection: true,
                reconnectionDelay: 5000,
                reconnectionAttempts: 13,
                query: queryParams
            }
        };

        const encryptionEnabled = grantResponseObj?.isSecureWsMsgEnabled === true;
        const signingPublicKeyPem = grantResponseObj?.socketE2ESigningPublicKeyPem || '';

        if (encryptionEnabled && !signingPublicKeyPem.trim()) {
            console.error('Socket E2E encryption is enabled but signing public key was not returned from load API');
            this.hostIns.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_WS_INIT']);
            return;
        }

        this.socketEncryption.configure({
            enabled: encryptionEnabled,
            signingPublicKeyPem,
        });

        this._agentAssistSocket = io(config.url, config.options);
        this.socketEncryption.attachSocket(this._agentAssistSocket);
        this.listenEvents();

        this._agentAssistSocket.on("connect", async () => {
            if (this.socketEncryption.isEnabled()) {
                try {
                    await this.socketEncryption.performHandshake(this._agentAssistSocket);
                } catch (err) {
                    console.error('Socket E2E handshake failed', err);
                    if (this._agentAssistSocket.connected) {
                        this._agentAssistSocket.disconnect();
                    }
                    this.hostIns.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_WS_INIT']);
                    return;
                }
            }

            this.hostIns.emit('ON_SOCKET_CONNECTION', configOptions);
            if(!this.hostIns.rootService.socketConnect){
                this.hostIns.rootService.socketConnect = true;
            }
            this.hostIns.emit(INTERNAL_EVENTS.FETCH_TRANSCRIPT, true);
        });

        this._agentAssistSocket.connect();

        this._agentAssistSocket.on('connect_error', (error: any) => {
            this.hostIns.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_WS_INIT']
            );
        });

         // Connection timeout
         this._agentAssistSocket.on('connect_timeout', (timeout: any) => {
            this.hostIns.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_WS_TIMEOUT']);
        });

        // Disconnection
        this._agentAssistSocket.on('disconnect', (reason: string) => {
            this.hostIns.rootService.socketConnect = false;
            this.hostIns.cleanupEvents()
            this.hostIns.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_WS_DISCONNECT']);
        });

        // Reconnection failed
        this._agentAssistSocket.on('reconnect_failed', () => {
            this.hostIns.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_WS_RECONNECT_FAILED']);
        });

        // Error event
        this._agentAssistSocket.on('error', (error: any) => {
            this.hostIns.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_WS_GENERIC']);
        });
    }

    emitTransferEvent(){
        if(this.hostIns.rootService.internalTransfer && this.hostIns.rootService.internalTransferData && this.hostIns.rootService.internalTransferData?.transition == 'entry'){
          this.emitEvents(EVENTS.internal_transfer, this.hostIns.rootService.internalTransferData);
        }
    }

    emitEvents(eventName: string, requestParams: any, keepOldTraceId = false) {
        if(!this.hostIns.rootService.disableWidgetFlag){
            if(eventName === EVENTS.request_resolution_comments){
                this.hostIns.rootService.summaryInProgress = true;
            }
            if(requestParams.intentName && eventName === EVENTS.agent_assist_request && this.hostIns.rootService.proactiveMode){
                this.updateProactiveModeState(false);
                this.dialogEntityExtraction = true;
            }
            const { fromSAT, source, autoBotId, channel, interactiveLanguage, botId } = this.configOptions.connectionDetails;
            if (requestParams) {
                requestParams.isExtAD = fromSAT ? false : true;
                requestParams.source = source;
                requestParams.experience = channel;
                requestParams.traceId = (keepOldTraceId && requestParams.traceId) ? requestParams.traceId : 'ua-f0f3edc3-16ca-4e02-9363-4f48c602df62';
                requestParams.language = interactiveLanguage;
                requestParams.participant = this.hostIns.rootService.internalTransferData?.participant || {};
                requestParams.conversationId = this.hostIns.rootService.connectionDetails.conversationId;
            }
    
            if (eventName == 'internal_transfer') {
                requestParams.botId = botId;
            }
            this._agentAssistSocket.emit(eventName, requestParams);
        }
    }

    listenEvents() {

        this._agentAssistSocket.on(EVENTS.settings_response, (data: any) => {
            this.hostIns.emit(DATA_EVENTS.SETTINGS_RESPONSE, data);
        });
       
        this._agentAssistSocket.on(EVENTS.on_ready, (data: any) => {
            this.hostIns.emit(DATA_EVENTS.ON_READY, data);
        });

        this._agentAssistSocket.on(EVENTS.agent_assist_response, (data: any) => {
            if(data.onConnectTask  && this.hostIns.rootService.proactiveMode){
                this.updateProactiveModeState(false);
                this.dialogEntityExtraction = true;
            }
            this.hostIns.rootService.assistTabSessionId = '';
            if (data.sessionId) {
                this.hostIns.rootService.assistTabSessionId = data?.sessionId;
            }  
            let settimeoutTime = this.getTimeout();
            setTimeout(() => {
              this.hostIns.emit(DATA_EVENTS.AGENT_AI_RESPONSE, data);
            }, settimeoutTime);
        });

        this._agentAssistSocket.on(EVENTS.agent_menu_response, (data: any) => {
            this.hostIns.emit(DATA_EVENTS.AGENT_AI_MENU_RESPONSE, data);
        });

        this._agentAssistSocket.on(EVENTS.agent_coaching_response, (data: any) => {
            this.hostIns.emit(DATA_EVENTS.AGENT_COACHING_RESPONSES, data);
        });

        this._agentAssistSocket.on(EVENTS.checklist_step_response, (data: any) => {
            this.hostIns.emit(DATA_EVENTS.CHECKLIST_STEP_RESPONSE, data);
        });

        this._agentAssistSocket.on(EVENTS.prefs_response, (data:any)=>{
            this.hostIns.emit(DATA_EVENTS.PREFS_RESPONSE, data);
        })

        this._agentAssistSocket.on(EVENTS.checklist_response, (data: any) => {
            this.hostIns.emit(DATA_EVENTS.CHECKLIST_RESPONSE, data);
        });

        this._agentAssistSocket.on(EVENTS.realtime_sentiment_response, (data: any) => {
        });

        this._agentAssistSocket.on(EVENTS.agent_assist_custom_response, (data: any) => {
            this.hostIns.emit(DATA_EVENTS.AGENT_ASSIST_CUSTOM_RESPONSE, data);
        });

        this._agentAssistSocket.on(EVENTS.internal_transfer_response, (data: any) => {
            this.handleInternalTransferResponse(data);
        });

        this._agentAssistSocket.on(EVENTS.agent_assist_agent_response, (data: any) => {

            let settimeoutTime = this.getTimeout();
            setTimeout(() => {
              this.hostIns.rootService.sentSearchResponse = false;
              this.hostIns.rootService.myBotTabSessionId = '';
              if(data.sessionId) {
                this.hostIns.rootService.myBotTabSessionId = data?.sessionId;
              }
              this.hostIns.emit(DATA_EVENTS.AGENT_AI_AGENT_RESPONSE, data);
            },settimeoutTime);
        });

        this._agentAssistSocket.on(EVENTS.agent_assist_endoftask, (data: any) => {
            if(data.intType !== ProjConstants.MYBOT?.toLowerCase() && data?.intType !== ProjConstants.CUSTOM?.toLowerCase() && this.dialogEntityExtraction && !this.hostIns.rootService.proactiveMode){
                this.updateProactiveModeState(true);
                this.dialogEntityExtraction = false;
            }
            if(data?.intType === ProjConstants.CUSTOM?.toLowerCase()){
                this.hostIns.emit(DATA_EVENTS.END_OF_TASK_RESPONSE, data);
                return;
            }
            let settimeoutTime = this.getTimeout();
            setTimeout(() => {
              this.hostIns.emit(DATA_EVENTS.END_OF_TASK_RESPONSE, data);
            }, settimeoutTime);
        });

        this._agentAssistSocket.on(EVENTS.user_message, (data: any) => {
            this.hostIns.emit(DATA_EVENTS.USER_TRANSCRIPT_RESPONSE, data);
        });

        this._agentAssistSocket.on(EVENTS.agent_message, (data: any) => {
            this.hostIns.emit(DATA_EVENTS.AGENT_TRANSCRIPT_RESPONSE, data);
        });

        this._agentAssistSocket.on(EVENTS.agent_assist_user_message, (data: any) => {
            this.hostIns.emit(DATA_EVENTS.AGENT_ASSIST_USER_MESSAGE, data);
        });

        this._agentAssistSocket.on(EVENTS.agentic_response, (data: any) => { 
            this.hostIns.emit(DATA_EVENTS.AGENTIC_RESPONSE, data);
        });

        this._agentAssistSocket.on(EVENTS.agent_feedback_response, (data: any) => {
            this.hostIns.emit(DATA_EVENTS.AGENT_FEEDBACK_RESPONSE, data);
        });

        this._agentAssistSocket.on(EVENTS.response_resolution_comments, (data: any) => {
            if(data?.isDisabled){
                return;
            }
            const isFinal = data.type === 'final';
            if(isFinal){
                this.hostIns.rootService.finalSummaryGenerated = true;
                this.hostIns.localStorageService.setFinalSummaryGenerated(true);
            }
            if(data.participant.identity){
                let isCurrentParticipant = this.isValidParticipant(data.participant);
                if(!isCurrentParticipant && !isFinal){
                    return;
                }
            }
            this.hostIns.rootService.summaryInProgress = false;
            if(data.type == 'interim'){
                this.hostIns.rootService.currentGenIntSummaryCount++;
            }
            this.hostIns.emit(DATA_EVENTS.RESOLUTION_COMMENTS_RESPONSE, data);
        })

        this._agentAssistSocket.on(EVENTS.agentassist_control_response, (data: any) => {
            this.handleMakeActiveOrPassive(data);
        });

        this._agentAssistSocket.on(EVENTS.realtime_sentiment_response, (data : any) => {
            this.hostIns.emit(DATA_EVENTS.REALTIME_SENTIMENT_RESPONSE, data);
        });

        this._agentAssistSocket.on(EVENTS.summaries_response, (data : any) =>{
            if(data.participant.identity){
                let isCurrentParticipant = this.isValidParticipant(data.participant);
                if(!isCurrentParticipant){
                    return;
                }
            }
            this.hostIns.rootService.currentGenIntSummaryCount = data.count;
            this.hostIns.rootService.generatedSummaries = data.summaries;
            this.hostIns.rootService.finalSummaryGenerated = data.summaries.some((item : any) => item.type === 'final');
            this.hostIns.localStorageService.setFinalSummaryGenerated(this.hostIns.rootService.finalSummaryGenerated);
        });

        this._agentAssistSocket.on(EVENTS.summaries_feedback_response, (data : any) =>{
            if(data.participant.identity){
                let isCurrentParticipant = this.isValidParticipant(data.participant);
                if(!isCurrentParticipant){
                  return;
                }
            }
            const feedbackMap = data?.feedbacks?.reduce((acc : any, item : any) => {
              acc[item.positionId] = item;
              return acc;
            }, {});
            (this.hostIns.rootService.generatedSummaries || []).forEach((item : any) => {
              if(feedbackMap[item.positionId]){
                item.summaryFeedbackData = feedbackMap[item.positionId];
                item.summaryFeedbackData.traceId = data.traceId;
              }
            });            
            this.hostIns.emit(INTERNAL_EVENTS.GENERATE_INTERIM_SUMMARY, true);
            this.hostIns.rootService.isSummariesGenerated = true;
        });

        this._agentAssistSocket.on(EVENTS.agentic_start, (data : any) => {
            this.hostIns.rootService.agenticStart = true;
            this.hostIns.emit(INTERNAL_EVENTS.AGENTIC_START, data);
        });

        this._agentAssistSocket.on(EVENTS.agentic_end, (data : any) => {
            this.hostIns.rootService.agenticStart = false;
            this.hostIns.emit(INTERNAL_EVENTS.AGENTIC_END, data);
        });

        this._agentAssistSocket.on(EVENTS.agentic_request_ack, (data : any) => {
            this.hostIns.emit(INTERNAL_EVENTS.AGENTIC_REQUEST_ACK, data);
        });
    }

    isValidParticipant(participant : any){
        if(Object.keys(participant).length === 0){
            return false;
        }
        try{
          return participant?.identity?.trim() === this.hostIns.rootService.internalTransferData?.participant?.identity?.trim();
        }catch(e){
          return false;
        }
    }


    getTimeout(){
        let timestamp1 = Date.now();
        let settimeoutTime = this.intervalTime;
        if ((timestamp1 - this.prevTimeStamp) < this.intervalTime) {
          settimeoutTime = (settimeoutTime * this.count) + (this.intervalTime - (timestamp1 - this.prevTimeStamp));
          this.count += 1;
        }else{
          this.count = 1;
        }
        this.prevTimeStamp = timestamp1;
        return settimeoutTime;
    }

    disconnect(){
        if (this._agentAssistSocket && this._agentAssistSocket.connected) {
            this.hostIns.rootService.socketConnect = false;
            this._agentAssistSocket.disconnect();
            this._agentAssistSocket.off();
        }
    }

    handleInternalTransfer(data: any, isHooksApi: boolean = false) {

        if(data && data?.isAnonymousAgent){
            this.hostIns.rootService.internalTransfer = true;
            let anonymousId = KoreGenerateuuidPipe('an');
            const anonymousAgentData = {
                participant: {
                    identity: anonymousId,
                    name: "Anonymous",
                    type: "agent",
                    transition: 'entry',
                    transfertype: 'NA',
                    isAnonymous: true
                },
                transition: 'entry',
                isAnonymous: true
            };
            this.hostIns.rootService.internalTransferData = {...anonymousAgentData, conversationId: this.hostIns.rootService.connectionDetails.conversationId};
            this.hostIns.localStorageService.setInternalTransferInfo(this.hostIns.rootService.internalTransferData);
            if(!this.hostIns.rootService.isInitialInternalTransferTriggered){
                this.emitTransferEvent();
            }
        }

        if (data && !data?.isAnonymousAgent) {
            this.hostIns.rootService.internalTransfer = true;
            const internalTransferDataInLocalStorage = this.hostIns.localStorageService.getInternalTransferInfo();

            if(internalTransferDataInLocalStorage){
                const anonymousId = internalTransferDataInLocalStorage?.participant?.identity || data?.participant?.identity;
                const incomingParticipant = data?.participant ||  {};

                if(data.transition === 'exit'){
                    data = {...data, ...internalTransferDataInLocalStorage, transition: data?.transition, transfertype: data?.transfertype}

                    data.participant = {
                        ...incomingParticipant,
                        identity: incomingParticipant?.identity ? incomingParticipant?.identity : anonymousId,
                        ...(!incomingParticipant?.identity && { participantId: incomingParticipant.identity })
                    }

                }else{
                    data = {...data, ...internalTransferDataInLocalStorage, transition: data?.transition, transfertype: data?.transfertype}
                    
                    data.participant = {
                        ...incomingParticipant,
                        identity: anonymousId,
                        participantId: incomingParticipant?.identity
                    }

                }

            }

            data.isAnonymous = false;
            data.isDisabled = false;
            this.hostIns.rootService.internalTransferData = {...data, conversationId: this.hostIns.rootService.connectionDetails.conversationId};
            this.hostIns.localStorageService.setInternalTransferInfo(this.hostIns.rootService.internalTransferData);
            if(!this.hostIns.rootService.isInitialInternalTransferTriggered && data?.transition !== 'exit'){
                this.emitTransferEvent();
            }
        }

        if (data?.transfertype === 'warm' && data.transition === 'entry') {                
            this.hostIns.emit(INTERNAL_EVENTS.DISABLE_WIDGET, true);
            data.isDisabled = true;
        }

        if (data && data?.transition === 'exit') {
            if (this.hostIns.rootService.aaSettings?.transferConfigs &&
                this.hostIns.rootService.aaSettings?.transferConfigs[data?.transfertype]?.actionType === 'task' &&
                this.hostIns.rootService.isAutomationOnGoing) {
                this.hostIns.rootService.sendRunClickEvent(this.hostIns, { intentName: ProjConstants.DISCARD_ALL, positionId: this.hostIns.rootService.currentAutomationId });
            }
            this.emitEvents(EVENTS.internal_transfer, data);
        }

        if(isHooksApi){
            this.hostIns.rootService.isHooksApi = false;
        }
    }

    handleInternalTransferResponse(data: any){
        if(data?.requestType === 'internal_transfer_via_api'){
            if(!this.hostIns?.localStorageService?.getInternalTransferInfo()){
                this.hostIns.rootService.isHooksApi = true;
                this.handleInternalTransfer(data,true);
                return;
            }
            if(this.hostIns?.localStorageService?.getInternalTransferInfo() && this.hostIns?.rootService?.internalTransferData?.isAnonymous){
                this.hostIns.rootService.isHooksApi = true;
                this.handleInternalTransfer(data,true);
                return;
            }

            if(this.hostIns?.localStorageService?.getInternalTransferInfo() && (this.hostIns?.rootService?.internalTransferData?.participant?.identity === data?.participant?.identity)){
                this.hostIns.rootService.isHooksApi = true;
                this.handleInternalTransfer(data,true);
                return;
            }

            if(this.hostIns?.localStorageService?.getInternalTransferInfo() && (this.hostIns?.rootService?.internalTransferData?.participant?.participantId === data?.participant?.identity)){
                this.hostIns.rootService.isHooksApi = true;
                this.handleInternalTransfer(data,true);
                return;
            }
            return;
        }

        if(data?.isAnonymous && data?.participant?.identity === this.hostIns.rootService.internalTransferData?.participant?.identity){
            this.hostIns.rootService.internalTransferData = {...data, conversationId: this.hostIns.rootService.connectionDetails.conversationId};
            this.hostIns.rootService.internalTransferData.participant = {...data?.participant}
            this.hostIns.localStorageService.setInternalTransferInfo(data);
        }
    }

    handleMakeActiveOrPassive(data : any){
        let appState = this.hostIns.localStorageService.getConvObjFromLS();
        if(appState[storageConst.INTERNAL_TRANSFER]){
            let internalTransferDetails = appState[storageConst.INTERNAL_TRANSFER];
            if(internalTransferDetails?.participant?.identity === data?.participant?.identity){
                data.isDisabled = data?.allowAccess;
                this.hostIns.disableWidget(!data?.allowAccess);
            }
            this.hostIns.localStorageService.setInternalTransferInfo(data);
        }
    }

    
     /**
     * Emits a scroll event with activity details through the websocket
     * @param eventType The type of scroll event that occurred
     */
    sendScrollEvent(eventType: string, tab = ProjConstants.ASSIST): void {
        const params = {
            ...this.commonRequestParams(),
            eventType,
            tab
        };
        this.emitEvents(EVENTS.agent_activity_request, params);
    }

    /**
     * Creates common request parameters used across socket events
     * @returns Object containing standard request parameters
     */
    private commonRequestParams(): {
        botId: string;
        conversationId: string;
        event: string;
        participant: any;
    } {
        const { botId, conversationId } = this.hostIns.rootService.connectionDetails;

        return {
            botId,
            conversationId,
            event: "clicked",
            participant: this.hostIns.rootService.internalTransferData?.participant || {}
        };
    }

    updateProactiveModeState(toggleProactiveMode=false){        
        if(!this.hostIns.rootService.aaSettings?.isEntityExtractionEnabled && this.hostIns.rootService.aaSettings?.isProactiveEnabled && (this.hostIns.rootService?.proactiveMode || toggleProactiveMode)){
           this.hostIns.chatEle.querySelector(`#${IdMapConstant.PROACTIVE_BTN}`)?.click();
        };
    }

}
export default websocketservice;
